import React, { useState, useEffect, useContext, useRef, useCallback } from "react";

import NavContext from "../../context/NavContext";
import CabineDetailsDrawer from "./cabine/CabineDetailsDrawer";

import { useCabineContext } from "../../context/CabineContext";
import InfosUser from "./infos/InfosUser";
import styles from "./SuperAdmin.module.scss";

import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import { FiSettings, FiMapPin, FiFileText, FiBarChart2, FiHeadphones, FiCpu, FiVolume2, FiCopy, FiRefreshCw, FiTrendingUp, FiTrendingDown } from "react-icons/fi";
import { GiBoneKnife } from "react-icons/gi";
import { MdHearing } from "react-icons/md";


import InfosCabine from "./infos/InfosCabine";

import SelectConfigCabine from "./cabine/SelectConfigCabine";
import Axios from "../../_services/caller.service";
import { motion } from "framer-motion";
import { animatePage } from "../../animation/animationPage";
import InfosConnexion from "./infos/InfosConnexion";
import { useNavigate } from "react-router-dom";
import LoaderLogin from "../UiComponents/loader/LoaderLogin";
import { useTranslation } from "react-i18next";
import SearchAll from "./search/SearchAll";
import MiniCardToggle from "../UiComponents/card/MiniCardToggle";
import RightDrawer from "../Rightpanel/RightDrawer";
import CalibrationDrawer from "./calibration/CalibrationDrawer";
import {
  displayCalibValue,
  ticksToDate,
} from "../calibration/functionDataSorted";



const SuperAdmin = () => {
  const { t } = useTranslation();
  //CONTEXT
  const {
    ownerId,
    setOwnerId,
    majCabine,
    setMajCabine,
    setDisplayOwnerWithoutCabine,
  } = useContext(NavContext);
  const navigate = useNavigate();
  const { cabine } = useCabineContext(); //all cabine owner
  //USER
  const [allUser, setAllUser] = useState([]);
  const [infosUser, setInfosUser] = useState([]);
  const [infosLinkOwnerCab, setInfosLinkOwnerCab] = useState(""); //cabid for infos link at which owner
  const [userIsOwner, setUserIsOwner] = useState(false);
  const [inviteOwnerId, setInviteOwnerId] = useState(""); // stockes l'id du owner de l'invité
  const [ownerLink, setOwnerLink] = useState(""); // stockes l'id du owner qui est aussi user d'un autre owner

  const [userType, setUserType] = useState("");
  const [displaySelectConnexion, setDisplaySelectConnexion] = useState(false);
  const [displayConnectingUser, setDisplayConnectingUser] = useState(false);
  const [cabineAccess, setCabineAccess] = useState(true);
  const [
    displayConnectingUserWithCabineSearch,
    setDisplayConnectingUserWithCabineSearch,
  ] = useState(false);

  //ABO
  const [orders, setOrders] = useState([]);
  const [aboId, setAboId] = useState(""); // stockes la valeur du select de l'abonnement
  const [defaultAboId, setDefaultAboId] = useState(0); //  recupère l'abonnement qui est chargé en 1er pour affichage dans le select par default
  const [variationId, setVariationId] = useState(""); // Product Variation
  //CABINE
  const [cabId, setCabId] = useState("");
  const [cabinesByAbo, setCabinesByAbo] = useState([]); // only cabine by abo
  const [updateCabType, setUpdateCabType] = useState("");
  const [infosCabId, setInfosCabId] = useState(""); //cabid for infos link at which owner
  const [allCabines, setAllCabines] = useState([]);
  const [cabname, setCabname] = useState("");
  const [displaySettingCab, setDisplaySettingCab] = useState(true); // display settings cab
  const [loading, setLoading] = useState(false);
  const [reloadWooApi, setReloadWooApi] = useState(false);
  const [maj, setMaj] = useState(false); // MAJ lors de changement

  const [displayInfosOwnerLinkCab, setDisplayInfosOwnerLinkCab] =
    useState(false); //display infos owner link cabine
  const [displayInfosOwnerLinkUser, setDisplayInfosOwnerLinkUser] =
    useState(false); //display infos owner link cabine

  const [isSearchingCab, setIsSearchingCab] = useState(false);
  const [isSearchingUser, setIsSearchingUser] = useState(false);
  const [isSearchingSettingCab, setIsSearchingSettingCab] = useState(false);

  //MINICARDTOGGLE
  const [calibrationStates, setCalibrationStates] = useState({
    sound: { date: "", warning: "" },
    speakers: { date: "", warning: "" },
    bone: { date: "", warning: "" },
    headphone: { date: "", warning: "" },
    inserts: { date: "", warning: "" },
    operator: { date: "", warning: "" },
  });

  // DRAWER CALIBRATION
  const [drawerCalibOpen, setDrawerCalibOpen] = useState(false);
  const [drawerCalibSection, setDrawerCalibSection] = useState("sound");
  const openCalibDrawer = useCallback((section) => {
    setDrawerCalibSection(section);
    setDrawerCalibOpen(true);
  }, []);
  const closeCalibDrawer = useCallback(() => setDrawerCalibOpen(false), []);

  // DRAWER CABINE DETAILS
  const [drawerCabOpen, setDrawerCabOpen] = useState(false);
  const [drawerSection, setDrawerSection] = useState("settings");
  const openCabDrawer = useCallback((section) => {
    setDrawerSection(section);
    setDrawerCabOpen(true);
  }, []);
  const closeCabDrawer = useCallback(() => setDrawerCabOpen(false), []);

  // CARD SUMMARY DATA
  const [cardSummary, setCardSummary] = useState({
    linkMachine: null,
    hasDirac: false,
    addressFilled: null, // null = loading, true/false after fetch
    addressData: null,
    diracLicenceCount: 0,
    diracLicences: [],
    hasNotes: false,
  });

  // STATISTICS CARD DATA
  const [cabStats, setCabStats] = useState(null);
  const [cabStatsPrev, setCabStatsPrev] = useState(null);
  const [statsPeriod, setStatsPeriod] = useState(0);
  const [firstMetricDate, setFirstMetricDate] = useState(null);
  const [statsDateRange, setStatsDateRange] = useState(null); // { curStart, curEnd, prevStart, prevEnd }


  //CONTROLLER
  const controller = new AbortController();
  const signal = controller.signal;
  //pagination State

  //FILTER
  const [searchCab, setSearchCab] = useState(""); // search cabine by name
  const [searchUser, setSearchUser] = useState(""); // search user
  const [searchCabines, setSearchCabines] = useState("");
  //PAGINATION
  const [currentPage, setCurrentPage] = useState(1);
  let initialCabPerPage = 2;
  const [cabPerPage, setCabPerPage] = useState(initialCabPerPage);
  // //lEVEL LOG
  // const [levelLog, setLevelLog] = useState("");

  useEffect(() => {
    if (cabine !== "") {
      const defaultCabineValueOnPageLoad = cabine.sort((a, b) =>
        a.cabname.localeCompare(b.cabname)
      )[0].id;

      // SI le select de selection de recherche dans toutes les cabines
      //HS est select alors on met la cabine dans cabid
      //pour que quand on selectionne une cabine elle aparaisse dans le select des cabines/centre
      if (infosCabId !== "") {
        setCabId(infosCabId);
      } else {
        setCabId(defaultCabineValueOnPageLoad);
      }
    }
  }, [cabine]);

  // GET ALL USER
  useEffect(() => {
    Axios.get(`/getAllUserForSuperAdmin`, { signal })

      .then(function async(response) {
        setAllUser(response.data.data);
      })
      .catch(function (error) {
        // console.log(error);
      });
    return () => {
      controller.abort();
    };
  }, []);

  // fonction avec le SELECT pour les user's
  const changeOwnerIdWithSelect = (e) => {
    const id = e.target.value;
    setOwnerId(id);
    setDisplayInfosOwnerLinkUser(true);
    setDisplayInfosOwnerLinkCab(false);
    setSearchUser("");
    setInfosCabId(""); // reset infos cabid
  };
  // fonction avec le SELECT pour les cabines
  const changeCabIdWithSelect = (e) => {
    const id = e.target.value;
    setInfosCabId(id);
    setCabId(id);
    setDisplayInfosOwnerLinkCab(true);
    setDisplayInfosOwnerLinkUser(false);
    setUserIsOwner(true);
    setSearchCab("");
  };

  // GET INFORMATION IF USER IS AN OWNER
  useEffect(() => {
    setDisplayConnectingUser(false);
    setCabineAccess(true);

    Axios.get(`/relationUser/${ownerId}`, { signal })
      .then(function async(response) {
        setDisplaySelectConnexion(true);

        const user = response.data.data.user;
        const ownerLink = response.data.data.owner; //les owner link
        const userTypeReceive = response.data.data.userType;
        setInfosUser(user);
        setOwnerLink(ownerLink);
        setUserType(userTypeReceive);

        if (displayConnectingUserWithCabineSearch) {
          setDisplayConnectingUser(true);
        }

        if (
          userTypeReceive !== "Owner et user d'un autre owner" &&
          userTypeReceive !== "Utilisateur des cabines d'un owner"
        ) {
          setDisplayConnectingUser(true);
        }

        if (userTypeReceive === "Aucun accès à une cabine") {
          setCabineAccess(false);
        }
      })
      .catch(function (error) {
        //  console.log(error);
      });
    return () => {
      controller.abort();
    };
  }, [ownerId]);

  // GET ALL CABINE AND SET A DEFAULT CABINE
  useEffect(() => {
    Axios.get(`/allCabines/`, { signal })

      .then(function async(response) {
        setAllCabines(response.data.data);
        //   setCabId(defaultCabineValueOnPageLoad)
      })
      .catch(function (error) {});
    return () => {
      controller.abort();
    };
  }, []);

  // GET OWNER LINK WITH A CABINE (owner or invite ...)
  useEffect(() => {
    if (infosCabId !== "") {
      Axios.get(`/relationCabine/${infosCabId}`, { signal })

        .then(function async(response) {
          setInfosLinkOwnerCab(response.data.data[0]);
          setInviteOwnerId(response.data.data[0].ID);
          setDisplayInfosOwnerLinkUser(true);
        })
        .catch(function (error) {});
      return () => {
        controller.abort();
      };
    }
  }, [infosCabId, setInfosCabId]);

  //Pagination method
  const indexOfLastPost = currentPage * cabPerPage;
  const indexOfFirstPost = indexOfLastPost - cabPerPage;
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // get cabin name for components that need it
  useEffect(() => {
    const cabnameForComponent = cabine
      .filter((cab) => cab.id == cabId)
      .map((cab) => cab.cabname);

    setCabname(cabnameForComponent);
  }, [cabId, cabine]);

  //FECTH DATE CALIBRATION GENERAL
  const fetchCalibrationGeneralDates = useCallback(async () => {
    if (!cabId) return;
    const newStates = {};

    try {
      const res = await Axios.get(`/calibrationGeneral/${cabId}`);

      if (
        res.data &&
        res.data.data &&
        res.data.data.length &&
        res.data.message !== "aucune donnée"
      ) {
        const data = res.data.data;

        const keys = [
          { key: "speakers", label: "Speakers_Passed" },
          { key: "bone", label: "Bone_Passed" },
          { key: "headphone", label: "Headphones_Passed" },
          { key: "inserts", label: "Inserts_Passed" },
          { key: "operator", label: "Operator_Passed" },
        ];

        keys.forEach(({ key, label }) => {
          const date = displayCalibValue(data, label)?.[0];
          newStates[key] = date
            ? { date, warning: "" }
            : { date: "", warning: t("superadmin.no_calibration") };
        });
      } else {
        ["speakers", "bone", "headphone", "inserts", "operator"].forEach((key) => {
          newStates[key] = { date: "", warning: t("superadmin.no_calibration") };
        });
      }

      setCalibrationStates((prev) => ({
        ...prev,
        ...newStates,
      }));
    } catch (err) {
      console.error("Erreur récupération calibrationGeneral", err);
      ["speakers", "bone", "headphone", "inserts", "operator"].forEach((key) => {
        newStates[key] = { date: "", warning: t("superadmin.fetch_error") };
      });
      setCalibrationStates((prev) => ({
        ...prev,
        ...newStates,
      }));
    }
  }, [cabId]);

  useEffect(() => {
    fetchCalibrationGeneralDates();
  }, [fetchCalibrationGeneralDates]);

  // FETCH CARD SUMMARY DATA
  useEffect(() => {
    if (!cabId) return;

    // LinkMachine + OptionalFeatures
    Axios.post(`/cabines/`, { data: cabId })
      .then((res) => {
        const machine = res.data.data[0]?.machine || "";
        setCardSummary((prev) => ({ ...prev, linkMachine: machine || null }));
      })
      .catch(() => {});

    Axios.get(`/optionalFeatures/${cabId}`)
      .then((res) => {
        const features = res.data.data[0]?.features?.split(",") || [];
        setCardSummary((prev) => ({ ...prev, hasDirac: features.includes("Dirac") }));
      })
      .catch(() => {});

    // Address
    Axios.get(`/cabineAdress/${cabId}`)
      .then((res) => {
        if (res.data.data) {
          const d = res.data.data;
          const filled = !!(d.Responsable || d.Tel || d.Adress || d.Ville || d.CodePostal || d.Pays);
          setCardSummary((prev) => ({
            ...prev,
            addressFilled: filled,
            addressData: filled ? d : null,
          }));
        } else {
          setCardSummary((prev) => ({ ...prev, addressFilled: false, addressData: null }));
        }
      })
      .catch(() => {
        setCardSummary((prev) => ({ ...prev, addressFilled: false, addressData: null }));
      });

    // Dirac licences
    Axios.get(`/getLicenceDiracLoginMdp/${cabId}`)
      .then((res) => {
        const data = res.data.data;
        setCardSummary((prev) => ({
          ...prev,
          diracLicenceCount: Array.isArray(data) ? data.length : 0,
          diracLicences: Array.isArray(data) ? data : [],
        }));
      })
      .catch(() => {});

    // Notes
    Axios.get(`/cabineNotes/${cabId}`)
      .then((res) => {
        const val = res.data.data?.[0]?.fval || "";
        setCardSummary((prev) => ({ ...prev, hasNotes: val !== "" }));
      })
      .catch(() => {});
  }, [cabId, majCabine]);

  // FETCH FIRST METRIC DATE FOR CABINE
  useEffect(() => {
    if (!cabId) return;
    setFirstMetricDate(null);
    Axios.get(`/firstMetricDate?cabid=${cabId}`)
      .then((res) => {
        if (!res.data.error && res.data.data) {
          setFirstMetricDate(res.data.data);
        } else {
          setFirstMetricDate(null);
        }
      })
      .catch(() => setFirstMetricDate(null));
  }, [cabId]);

  // Helpers pour les stats
  const statsToMap = (data) => {
    const result = {};
    if (Array.isArray(data)) {
      data.forEach((item) => { result[item.mname] = Number(item.totalValue) || 0; });
    }
    return result;
  };
  const statsBuildQs = (start, end) =>
    `startYear=${start.getFullYear()}&startMonth=${start.getMonth() + 1}&startDay=${start.getDate()}&endYear=${end.getFullYear()}&endMonth=${end.getMonth() + 1}&endDay=${end.getDate()}&cabids=${cabId}`;

  // FETCH STATS — MODE TOTAL (dépend de firstMetricDate)
  useEffect(() => {
    if (!cabId || statsPeriod !== 0) return;
    let cancelled = false;
    setCabStats(null);
    setCabStatsPrev(null);

    const now = new Date();
    const startDate = firstMetricDate
      ? new Date(firstMetricDate.year, firstMetricDate.month - 1, firstMetricDate.day)
      : new Date(2015, 0, 1);
    const qs = statsBuildQs(startDate, now);
    console.log('[Stats] Total fetch:', qs);
    Axios.get(`/generalStats?${qs}`)
      .then((res) => {
        if (cancelled) return;
        const mapped = !res.data.error ? statsToMap(res.data.data) : {};
        console.log('[Stats] Total mapped:', mapped);
        setCabStats(mapped);
      })
      .catch(() => { if (!cancelled) setCabStats({}); });

    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cabId, statsPeriod, firstMetricDate]);

  // FETCH STATS — MODE PÉRIODE (7j/30j/365j) — PAS de dépendance firstMetricDate
  useEffect(() => {
    if (!cabId || statsPeriod === 0) return;
    let cancelled = false;
    setCabStats(null);
    setCabStatsPrev(null);

    const now = new Date();
    const currentStart = new Date(now);
    currentStart.setHours(0, 0, 0, 0);
    currentStart.setDate(now.getDate() - statsPeriod);
    const prevEnd = new Date(currentStart);
    prevEnd.setDate(currentStart.getDate() - 1);
    const prevStart = new Date(prevEnd);
    prevStart.setDate(prevEnd.getDate() - statsPeriod + 1);

    const fmtDate = (d) => `${String(d.getDate()).padStart(2,'0')}/${String(d.getMonth()+1).padStart(2,'0')}/${d.getFullYear()}`;
    setStatsDateRange({
      curStart: fmtDate(currentStart),
      curEnd: fmtDate(now),
      prevStart: fmtDate(prevStart),
      prevEnd: fmtDate(prevEnd),
    });

    const qsCurrent = statsBuildQs(currentStart, now);
    const qsPrev = statsBuildQs(prevStart, prevEnd);

    console.log(`[Stats] ${statsPeriod}j current: ${fmtDate(currentStart)} → ${fmtDate(now)}`, qsCurrent);
    console.log(`[Stats] ${statsPeriod}j prev: ${fmtDate(prevStart)} → ${fmtDate(prevEnd)}`, qsPrev);

    Promise.all([
      Axios.get(`/generalStats?${qsCurrent}`).catch(() => ({ data: { error: true } })),
      Axios.get(`/generalStats?${qsPrev}`).catch(() => ({ data: { error: true } })),
    ]).then(([resCur, resPrev]) => {
      if (cancelled) return;
      const mappedCur = !resCur.data.error ? statsToMap(resCur.data.data) : {};
      const mappedPrev = !resPrev.data.error ? statsToMap(resPrev.data.data) : {};
      console.log(`[Stats] ${statsPeriod}j FINAL cur:`, mappedCur, 'prev:', mappedPrev);
      setCabStats(mappedCur);
      setCabStatsPrev(mappedPrev);
    });

    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cabId, statsPeriod]);

  return (
    <>
      <motion.div
        variants={animatePage}
        initial="hidden"
        animate="visible"
        exit="exit"
        className={styles.containerSuperAdmin}
        onClick={() => {
          setIsSearchingCab(false);
          setIsSearchingUser(false);
        }}
      >
        {loading && <LoaderLogin />}

        <SearchAll
          allUser={allUser}
          allCabines={allCabines}
          changeOwnerIdWithSelect={changeOwnerIdWithSelect}
          changeCabIdWithSelect={changeCabIdWithSelect}
          ownerId={ownerId}
          infosCabId={infosCabId}
        />

        {!loading && !userIsOwner && displayInfosOwnerLinkUser && (
          <InfosUser
            setOwnerId={setOwnerId}
            userIsOwner={userIsOwner}
            inviteOwnerId={inviteOwnerId}
            infosUser={infosUser}
            ownerId={ownerId}
            ownerLink={ownerLink}
            userType={userType}
            displaySelectConnexion={displaySelectConnexion}
            setDisplaySelectConnexion={setDisplaySelectConnexion}
            setDisplayConnectingUser={setDisplayConnectingUser}
            displayConnectingUser={displayConnectingUser}
            cabineAccess={cabineAccess}
          />
        )}

        {!loading && displayInfosOwnerLinkCab && (
          <InfosCabine
            setOwnerId={setOwnerId}
            ownerName={infosLinkOwnerCab.display_name}
            login={infosLinkOwnerCab.user_login}
            email={infosLinkOwnerCab.user_email}
            date={infosLinkOwnerCab.user_registered}
            inviteOwnerId={inviteOwnerId}
            setdisplayInfosOwnerLinkCab={setDisplayInfosOwnerLinkCab}
            setDisplayConnectingUser={setDisplayConnectingUser}
            setDisplayConnectingUserWithCabineSearch={
              setDisplayConnectingUserWithCabineSearch
            }
          />
        )}

        {cabineAccess && (
          <>
            <SelectConfigCabine
              cabine={cabine}
              setCabId={setCabId}
              cabId={cabId}
              setIsSearchingSettingCab={setIsSearchingSettingCab}
              isSearchingSettingCab={isSearchingSettingCab}
            />
            {cabname && (
              <div className={styles.currentCabBanner}>
                <span className={styles.currentCabLabel}>{t("superadmin.selected_cabine")}</span>
                <h2 className={styles.currentCabName}>{cabname}</h2>
              </div>
            )}
          </>
        )}

        {cabine &&
          cabineAccess &&
          cabine
            .filter((cab) => cab.id == cabId)
            .map((cab) => (
              <React.Fragment key={cab.id}>
                <div className={styles.containerCardInjectCalibration}>
                  {/* Card 1 — Paramètres cabine */}
                  <MiniCardToggle
                    title={t("superadmin.cabine_settings")}
                    icon={<FiSettings />}
                    isOpen={drawerCabOpen && drawerSection === "settings"}
                    onToggle={() => openCabDrawer("settings")}
                    footerContent={
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
                        <span
                          className={cardSummary.linkMachine ? styles.badgeSuccessLg : styles.badgeDangerLg}
                        >
                          {cardSummary.linkMachine ? t("superadmin.machine_linked") : t("superadmin.not_linked")}
                        </span>
                        {cardSummary.hasDirac && (
                          <span className={styles.badgeInfoLg}>{t("superadmin.dirac_enabled")}</span>
                        )}
                      </div>
                    }
                  />

                  {/* Card 2 — Adresse cabine */}
                  <MiniCardToggle
                    title={t("superadmin.cabine_address")}
                    icon={<FiMapPin />}
                    isOpen={drawerCabOpen && drawerSection === "address"}
                    onToggle={() => openCabDrawer("address")}
                    footerContent={
                      cardSummary.addressFilled === null ? (
                        <span className={styles.badgeNeutral}>{t("superadmin.loading")}</span>
                      ) : cardSummary.addressFilled && cardSummary.addressData ? (
                        <div className={styles.addressLines}>
                          {cardSummary.addressData.Responsable && (
                            <span>{cardSummary.addressData.Responsable}</span>
                          )}
                          {cardSummary.addressData.Adress && (
                            <span>{cardSummary.addressData.Adress}</span>
                          )}
                          {cardSummary.addressData.Adress2 && (
                            <span>{cardSummary.addressData.Adress2}</span>
                          )}
                          {(cardSummary.addressData.CodePostal || cardSummary.addressData.Ville) && (
                            <span>{[cardSummary.addressData.CodePostal, cardSummary.addressData.Ville].filter(Boolean).join(" ")}</span>
                          )}
                          {cardSummary.addressData.Pays && (
                            <span>{cardSummary.addressData.Pays}</span>
                          )}
                          {cardSummary.addressData.Tel && (
                            <span>{t("superadmin.phone_prefix", { phone: cardSummary.addressData.Tel })}</span>
                          )}
                        </div>
                      ) : (
                        <span className={styles.badgeWarning}>{t("superadmin.not_filled")}</span>
                      )
                    }
                  />

                  {/* Card 3 — Informations spécifiques */}
                  <MiniCardToggle
                    title={t("superadmin.specific_infos")}
                    icon={<FiFileText />}
                    isOpen={drawerCabOpen && drawerSection === "infos"}
                    onToggle={() => openCabDrawer("infos")}
                    footerContent={
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
                        {cardSummary.diracLicences.length > 0 ? (
                          cardSummary.diracLicences.map((lic, i) => (
                            <div key={i} className={styles.diracPreview}>
                              <div className={styles.diracRow}>
                                <span className={styles.diracValue}>{lic.Login?.includes('@') ? lic.Login.split('@')[0] + '@...' : lic.Login}</span>
                                <FiCopy
                                  className={`${styles.diracCopy} has-tooltip`}
                                  aria-label={t("superadmin.copy_login")}
                                  onClick={(e) => { e.stopPropagation(); navigator.clipboard.writeText(lic.Login); }}
                                />
                              </div>
                              <div className={styles.diracRow}>
                                <span className={styles.diracValue}>{lic.mdp}</span>
                                <FiCopy
                                  className={`${styles.diracCopy} has-tooltip`}
                                  aria-label={t("superadmin.copy_password")}
                                  onClick={(e) => { e.stopPropagation(); navigator.clipboard.writeText(lic.mdp); }}
                                />
                              </div>
                            </div>
                          ))
                        ) : (
                          <span className={styles.badgeNeutral}>{t("superadmin.no_dirac_licence")}</span>
                        )}
                        {cardSummary.hasNotes && (
                          <span className={styles.badgeInfo}>{t("superadmin.notes")}</span>
                        )}
                      </div>
                    }
                  />

                  {/* Card 4 — Statistiques cabine */}
                  <MiniCardToggle
                    title={t("superadmin.statistics")}
                    icon={<FiBarChart2 />}
                    footerContent={
                      cabStats === null ? (
                        <span className={styles.badgeNeutral}>{t("superadmin.loading")}</span>
                      ) : (
                        <div className={styles.statsGrid}>
                          <div className={styles.statsPeriodSelector}>
                            {[{ value: 0, label: 'Total' }, { value: 7, label: '7j' }, { value: 30, label: '30j' }, { value: 365, label: '1an' }].map(({ value, label }) => (
                              <button
                                key={value}
                                type="button"
                                className={`${styles.statsPeriodBtn} ${statsPeriod === value ? styles.statsPeriodActive : ''}`}
                                onClick={(e) => { e.stopPropagation(); setStatsPeriod(value); }}
                              >
                                {label}
                              </button>
                            ))}
                          </div>
                          {statsPeriod === 0 && firstMetricDate && (
                            <span className={styles.statsPeriodInfo}>
                              {t("superadmin.since_date", { date: `${String(firstMetricDate.day).padStart(2, '0')}/${String(firstMetricDate.month).padStart(2, '0')}/${firstMetricDate.year}` })}
                            </span>
                          )}
                          {statsPeriod === 0 && !firstMetricDate && (
                            <span className={styles.statsPeriodInfo}>{t("superadmin.no_data")}</span>
                          )}
                          {statsPeriod !== 0 && statsDateRange && (
                            <span className={styles.statsPeriodInfo}>
                              {statsDateRange.curStart} → {statsDateRange.curEnd}
                            </span>
                          )}
                          {statsPeriod !== 0 && Object.keys(cabStats).length === 0 && (
                            <span className={styles.statsPeriodInfo}>{t("superadmin.no_activity_period")}</span>
                          )}
                          {(() => {
                            const stats = cabStats || {};
                            const prev = cabStatsPrev || {};
                            const rows = [
                              { label: t("superadmin.hs_started"), cur: stats.HSStarted || 0, prev: prev.HSStarted || 0 },
                              { label: t("superadmin.reports"), cur: stats.ReportsGenerated || 0, prev: prev.ReportsGenerated || 0 },
                              { label: t("superadmin.calibrations"), cur: (stats.SpeakersCalibrationCompleted || 0) + (stats.HeadphonesCalibrationCompleted || 0) + (stats.InsertsCalibrationCompleted || 0), prev: (prev.SpeakersCalibrationCompleted || 0) + (prev.HeadphonesCalibrationCompleted || 0) + (prev.InsertsCalibrationCompleted || 0) },
                              { label: t("superadmin.audiograms"), cur: (stats.TonalAudiogramSaved || 0) + (stats.VocalAudiogramSaved || 0) + (stats.TSTAudiogramSaved || 0) + (stats.LocalisationTestSaved || 0), prev: (prev.TonalAudiogramSaved || 0) + (prev.VocalAudiogramSaved || 0) + (prev.TSTAudiogramSaved || 0) + (prev.LocalisationTestSaved || 0) },
                            ];
                            return rows.map(({ label, cur, prev: p }) => (
                              <div className={styles.statRow} key={label}>
                                <span className={styles.statLabel}>{label}</span>
                                <div className={styles.statValueRow}>
                                  <span className={styles.statValue}>{cur}</span>
                                  {statsPeriod !== 0 && cur > p && <FiTrendingUp className={styles.trendUp} />}
                                  {statsPeriod !== 0 && cur < p && <FiTrendingDown className={styles.trendDown} />}
                                  {statsPeriod !== 0 && cur === p && p > 0 && <span className={styles.trendNeutral}>=</span>}
                                  {statsPeriod !== 0 && <span className={styles.statPrev}>({p})</span>}
                                </div>
                              </div>
                            ));
                          })()}
                        </div>
                      )
                    }
                  />
                </div>

                <RightDrawer
                  isOpen={drawerCabOpen}
                  onClose={closeCabDrawer}
                  title={`${cab.cabname} (${cab.id})`}
                  width="720px"
                >
                  <CabineDetailsDrawer
                    cab={cab}
                    cabId={cabId}
                    setCabId={setCabId}
                    aboId={aboId}
                    maj={maj}
                    setMaj={setMaj}
                    updateCabType={updateCabType}
                    setUpdateCabType={setUpdateCabType}
                    cabinesByAbo={cabinesByAbo}
                    displaySettingCab={displaySettingCab}
                    setDisplaySettingCab={setDisplaySettingCab}
                    cabineAccess={cabineAccess}
                    isSearchingSettingCab={isSearchingSettingCab}
                    setIsSearchingSettingCab={setIsSearchingSettingCab}
                    majCabine={majCabine}
                    setMajCabine={setMajCabine}
                    initialSection={drawerSection}
                  />
                </RightDrawer>
              </React.Fragment>
            ))}

        {cabineAccess && (
          <>
            <div className={styles.containerCardInjectCalibration} >

              <MiniCardToggle
                title={t("superadmin.sound_cards")}
                icon={<FiCpu />}
                isOpen={drawerCalibOpen && drawerCalibSection === "sound"}
                onToggle={() => openCalibDrawer("sound")}
                footerContent={<span>{t("superadmin.view_available_cards")}</span>}
              />

              <MiniCardToggle
                title={t("superadmin.config_cl")}
                icon={<FiVolume2 />}
                isOpen={drawerCalibOpen && drawerCalibSection === "speakers"}
                onToggle={() => openCalibDrawer("speakers")}
                footerContent={
                  calibrationStates.speakers.date ? (
                    <span className={styles.badgeSuccessLg}>
                      {ticksToDate(calibrationStates.speakers.date)}
                    </span>
                  ) : (
                    <span className={styles.badgeDangerLg}>
                      {calibrationStates.speakers.warning}
                    </span>
                  )
                }
              />

              <MiniCardToggle
                title={t("superadmin.config_co")}
                icon={<GiBoneKnife />}
                isOpen={drawerCalibOpen && drawerCalibSection === "bone"}
                onToggle={() => openCalibDrawer("bone")}
                footerContent={
                  calibrationStates.bone.date ? (
                    <span className={styles.badgeSuccessLg}>
                      {ticksToDate(calibrationStates.bone.date)}
                    </span>
                  ) : (
                    <span className={styles.badgeDangerLg}>
                      {calibrationStates.bone.warning}
                    </span>
                  )
                }
              />

              <MiniCardToggle
                title={t("superadmin.config_headphone")}
                icon={<FiHeadphones />}
                isOpen={drawerCalibOpen && drawerCalibSection === "headphone"}
                onToggle={() => openCalibDrawer("headphone")}
                footerContent={
                  calibrationStates.headphone.date ? (
                    <span className={styles.badgeSuccessLg}>
                      {ticksToDate(calibrationStates.headphone.date)}
                    </span>
                  ) : (
                    <span className={styles.badgeDangerLg}>
                      {calibrationStates.headphone.warning}
                    </span>
                  )
                }
              />

              <MiniCardToggle
                title={t("superadmin.config_inserts")}
                icon={<MdHearing />}
                isOpen={drawerCalibOpen && drawerCalibSection === "inserts"}
                onToggle={() => openCalibDrawer("inserts")}
                footerContent={
                  calibrationStates.inserts.date ? (
                    <span className={styles.badgeSuccessLg}>
                      {ticksToDate(calibrationStates.inserts.date)}
                    </span>
                  ) : (
                    <span className={styles.badgeDangerLg}>
                      {calibrationStates.inserts.warning}
                    </span>
                  )
                }
              />

            </div>

            <RightDrawer
              isOpen={drawerCalibOpen}
              onClose={closeCalibDrawer}
              title={t("superadmin.calibration_title", { cabname })}
              width="720px"
            >
              <CalibrationDrawer
                cabId={cabId}
                setCabId={setCabId}
                cabname={cabname}
                cabine={cabine}
                initialSection={drawerCalibSection}
                onCalibrationSaved={fetchCalibrationGeneralDates}
              />
            </RightDrawer>
          </>
        )}
      </motion.div>
    </>
  );
};

export default SuperAdmin;
